import { includes } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose, branch, renderNothing, renderComponent, withPropsOnChange, withHandlers } from 'recompose';
import { isApiReaderEnabledForShop } from '../../auth/selectors';
import { t } from '../../../modules/infra/i18n';

import ConnectionSpinner from './Spinner';
import { webreaderError } from '../../terminal/actions';
import { getReadersOnline, getReaderStage } from './selector';
import { selectReaderDone, selectReaderCancel } from './actions';

export default compose(
  connect(
    state => ({
      readers: getReadersOnline(state),
      showModal: state.register.webReader.showSelectReaderModal,
      stage: getReaderStage(state),
      isApiReader: isApiReaderEnabledForShop(state),
      selectedReader: state.register.webReader.selectedReader,
      strategy: state.register.webReader.webreaderStrategy,
    }),
    dispatch => ({
      cancel: bindActionCreators(selectReaderCancel, dispatch),
      selectReader: bindActionCreators(selectReaderDone, dispatch),
      showNotFoundError: bindActionCreators(webreaderError, dispatch),
    }),
  ),
  withPropsOnChange(
    ['showModal'],
    (props) => {
      if (props.showModal && !props.readers.length) {
        const message = props.isApiReader
          ? t('register:web_reader.reader_connection_api')
          : t('register:web_reader.reader_connection_network');

        props.showNotFoundError(
          {
            error: { message },
            config: { position: 'tc', title: t('register:web_reader.no_readers_found') },
          },
          props.strategy,
        );
        props.cancel(props.strategy);
      }
    }
  ),
  withHandlers({
    cancel: props => props.cancel.bind(null, props.strategy),
  }),
  branch(
    props => !includes([null, 'select', 'connected'], props.stage),
    renderComponent(ConnectionSpinner),
  ),
  branch(
    props => !props.showModal || !props.readers.length,
    renderNothing,
  ),
);
